import AccountModel from 'cio/models/account';
import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';
import AccountService from 'cio/services/account';
import isDestroyed from 'cio/utils/is-destroyed';

export default class EditRoute extends Route {
  @service account!: AccountService;

  crumb() {
    return {
      name: 'Edit',
      path: this.routeName,
    };
  }

  model() {
    return this.account.current;
  }

  deactivate() {
    // isDestroyed check needed for tests:
    if (!isDestroyed(this)) {
      (this.controller.model as AccountModel).rollbackAttributes();
    }

    super.deactivate();
  }
}
